import { render, staticRenderFns } from "./creditProofList.vue?vue&type=template&id=2c7c55f3"
import script from "./creditProofList.vue?vue&type=script&lang=js"
export * from "./creditProofList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports